import React, { useEffect, useState } from 'react';
import CreateUserModal from "../components/admin/CreateUserModal";
import EditUserModal from "../components/admin/EditUserModal";
import ConfirmDeleteModal from "../components/admin/ConfirmDeleteModal";
import { User } from '../types/user';

const AdminDashboard = () => {
    const [users, setUsers] = useState<User[]>([]);
    const [error, setError] = useState('');
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState<User | null>(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const fetchUsers = () => {
        const token = localStorage.getItem('adminToken');
        if (!token) {
            setError('Nicht eingeloggt');
            return;
        }

        fetch('/api/admin/users', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(res => res.json())
            .then(data => setUsers(data.users || []))
            .catch(() => setError('Fehler beim Laden der Benutzer'));
    };

    const handleDelete = async () => {
        if (!selectedUser) return;

        const token = localStorage.getItem('adminToken');
        await fetch(`/api/admin/users/${selectedUser._id}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        setShowDeleteModal(false);
        setSelectedUser(null);
        fetchUsers();
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    if (error) return <div className="p-4 text-red-500">{error}</div>;

    return (
        <div className="p-4 max-w-4xl mx-auto">
            <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>

            <button onClick={() => setShowCreateModal(true)} className="mb-4 bg-green-600 text-white px-4 py-2">
                Benutzer anlegen
            </button>

            <CreateUserModal
                isOpen={showCreateModal}
                onClose={() => setShowCreateModal(false)}
                onSuccess={fetchUsers}
            />

            <EditUserModal
                isOpen={showEditModal}
                onClose={() => setShowEditModal(false)}
                onSuccess={fetchUsers}
                user={selectedUser}
            />

            <ConfirmDeleteModal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleDelete}
                user={selectedUser}
            />

            <table className="w-full border">
                <thead>
                <tr className="bg-gray-200 text-left">
                    <th className="p-2">Vorname</th>
                    <th className="p-2">Nachname</th>
                    <th className="p-2">E-Mail</th>
                    <th className="p-2">Subscription</th>
                    <th className="p-2"># Configs</th>
                    <th className="p-2">Aktionen</th>
                </tr>
                </thead>
                <tbody>
                {users.map((u) => (
                    <tr key={u._id} className="border-t">
                        <td className="p-2">{u.firstName}</td>
                        <td className="p-2">{u.lastName}</td>
                        <td className="p-2">{u.email}</td>
                        <td className="p-2">{u.subscription}</td>
                        <td className="p-2">{u.configCount}</td>
                        <td className="p-2 flex gap-2">
                            <button
                                className="text-blue-600 underline"
                                onClick={() => {
                                    setSelectedUser(u);
                                    setShowEditModal(true);
                                }}
                            >
                                Bearbeiten
                            </button>
                            <button
                                className="text-red-600 underline"
                                onClick={() => {
                                    setSelectedUser(u);
                                    setShowDeleteModal(true);
                                }}
                            >
                                Löschen
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminDashboard;
